import React from 'react';
import { Grid, Row, Col } from "react-bootstrap";

import { StatsCard } from "../../../components/StatsCard/StatsCard.jsx";

const links = [
  {
    name: 'Agenda sala virtual',
    ref: '/#/sala-virtual',
    icon: 'ps-ico ps-glyph ps-ico-calendar',
    text: 'Acompanhe a agenda das transmissões ao vivo',
  },
  {
    name: 'Certificados',
    ref: '/#/certificados',
    icon: 'pe-7s-medal',
    text: 'Agora é a hora de ver seus certificados. Quanto mais, melhor!',
  },
  {
    name: 'Cursos',
    ref: '/#/cursos-online',
    icon: 'pe-7s-study',
    text: 'Veja cursos disponíveis para conseguir seu certificado.',
  },
];

const UtilLinks = () => (
  <div className="content">
    <div className="container box-home">
      <Grid fluid>
        <Row>
          {links.map(({ name, ref, icon, text }) =>
            <Col lg={4} sm={6}>
              <a
                data-gtm-type="click"
                data-gtm-clicktype="card"
                data-gtm-name={name}
                href={ref}>
                <StatsCard
                  bigIcon={<i className={icon} />}
                  statsTitle={name}
                  statsText={text}
                />
              </a>
            </Col>
          )}
        </Row>
      </Grid>
    </div>
  </div>
);

export default UtilLinks;



// WEBPACK FOOTER //
// ./src/views/Home/components/UtilLinks.jsx